var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.45898,
    cy: 11,
    r: 8.95898,
    stroke: "#006EC2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6582 6.45117V15H8.9707V8.39648L6.94336 9.04102V7.71094L10.4766 6.45117H10.6582Z",
    fill: "#006EC2"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOne);
export default __webpack_public_path__ + "static/media/one.8f2e8523ada242377ec1d68af5c1d002.svg";
export { ForwardRef as ReactComponent };